import React from 'react';
import styled from 'styled-components';
import { FONT } from '@constants/app';

export const BaseButtonWrapper = styled.button`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  box-shadow: none;
  transition: background-color 300ms, color 300ms;

  border-radius: 6px;
  white-space: nowrap;

  * {
    font-family: ${FONT.bold};
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
`;

// Everything beyond children/onClick/disabled is forwarded to the <button>. Without this, the
// `buttonProps` escape hatch that FlatButton / SkeletonButton / TransparentFlatButton all offer
// went nowhere: callers passing aria-pressed, aria-disabled or aria-label got no attribute on the
// element at all. `disabled` stays a styling-only prop — it drives $disabled and is deliberately
// not forwarded, so click handlers keep their own guards.
export const BaseButton = (props) => {
  const { children, onClick, disabled, ...rest } = props;
  return (
    <BaseButtonWrapper $disabled={disabled} onClick={onClick} {...rest}>
      {children}
    </BaseButtonWrapper>
  );
};
